
import { Injectable, Inject } from '@angular/core';
import * as myGlobals from '../globalPath';
import { Subject, BehaviorSubject, Observable } from "rxjs";
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { LanguageService } from './../../../services/language.service';
import { AuthPermissionsService } from 'src/app/services/auth-permissions-service';
import { Responce } from '../lookup-services/lookup.service';
import { StaticPermissionsEnum } from 'src/app/models/permissions-models/permissions.enums';

@Injectable()

export class AuthenticationServicesService {
  isLoggedin = new BehaviorSubject(<boolean>false);
  userRoles = new Subject<string[]>();
  quotaionSignalR = new Subject<any>();
  callSignalR = new Subject<any>();
  orderSignalR = new Subject<any>();
  loginSubject = new BehaviorSubject<boolean>(false);
  loadNotification = new Subject<any>();
  OnUserLoginSuccess = new Subject<any>();
  isInvoicePage = new BehaviorSubject(<boolean>false);
  constructor(
    private http: HttpClient,
    private translateService: TranslateService,
    @Inject(DOCUMENT) private document: Document,
    private languageService: LanguageService,
    private auth: AuthPermissionsService,
  ) { }

  // @Output() : EventEmitter<any> = new EventEmitter<any>();


  setLoggedIn(value) {
    this.isLoggedin.next(value);
    this.loginSubject.next(value)
  }

  setRoles(value) {
    this.userRoles.next(value);
  }


  login(username: string, password: string, deviceId) {
    return this.http.post(myGlobals.BaseUrlUserManagementNew + myGlobals.loginManagementUrl, JSON.stringify(//loginUrlUserManagement if one project
      {
        userName: username,
        password: password,
        deviceId: deviceId
      }
    ))
  }
  ResetPasswordByToken(obj: any): Observable<Responce<boolean>> {
    return this.http.post<Responce<boolean>>(myGlobals.BaseUrlUserManagementNew + myGlobals.ResetPasswordByToken, obj);
  }


  storeDataOnLoginComplete(user) {
    if (user && user.data && user.data.token) {
      localStorage.setItem('AlghanimCurrentUserId', JSON.stringify(user.data.id));
      localStorage.setItem('AlghanimNewUserId', JSON.stringify(user.data.id));
      localStorage.setItem('AlghanimCurrentUser', JSON.stringify(user));
      this.auth.setCurrentUserPermissions();
      if (user.data.languageCode == null) {
        user.data.languageCode = "en";
      }
      const lngCode = user.data.languageCode.toLowerCase();

      // if (lngCode == 'ur' || lngCode == 'ar' || lngCode == 'Ur' || lngCode == 'Ar') {
      //   this.document.body.style.direction = "rtl";
      // } else {
      //   this.document.body.style.direction = "ltr";
      // }
      this.languageService.lngIntoLocalStorage(lngCode);
      // this.translateService.setDefaultLang(user.data.languageCode.toLowerCase());

      this.languageService.changeLanguage(lngCode);

      this.translateService.use(user.data.languageCode.toLowerCase());
      this.setLoggedIn(true);
      
      if (user.data.roles[0] != "Technician" && (user.data.roles[0] != 'Call Center' || user.data.permissions.filter(x => x == StaticPermissionsEnum.Recieve_Call).length <= 0)) {
        // if (user.data.roles[0] != "Technician" &&) {
        this.loadNotification.next();
      }
    }
  }

  logout() {
    localStorage.removeItem('AlghanimCurrentUser');
    this.setLoggedIn(false);
  }

  isLoggedIn() {
    if (localStorage.getItem("AlghanimCurrentUser") == null) {
      this.setLoggedIn(false);
      return false;
    }
    else {
      return true;
    }
  }

  CurrentUser() {
    if (localStorage.getItem("AlghanimCurrentUser") == null) {
      this.setLoggedIn(false);
      return null;
    }
    else {
      this.setLoggedIn(true);
      this.setRoles(JSON.parse(localStorage.getItem("AlghanimCurrentUser")).data.roles);
      return JSON.parse(localStorage.getItem('AlghanimCurrentUser'));
    }
  }

}
